/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import authHeader from "./auth-header";
import http from "./http-common";
import { API_URLU } from "../config/constant";

const getUserById = (id) => {
  return axios.get(API_URLU + "user/" + id, { headers: authHeader() });
};
const getUsers = () => {
  return axios.get(API_URLU + "user", { headers: authHeader() });
};

const postUser = (data) => {
  return axios.post(API_URLU + "user", data, { headers: authHeader() });
};

const getCompById = (id) => {
  return axios.get(API_URLU + "company/" + id, { headers: authHeader() });
};

const getCompanies = () => {
  return axios.get(API_URLU + "company", { headers: authHeader() });
};

const postComp = (data) => {
  return axios.post(API_URLU + "company", data, { headers: authHeader() });
};

const getSystemById = (id) => {
  return axios.get(API_URLU + "system" + id, { headers: authHeader() });
};



const getSystems = () => {
  return axios.get(API_URLU + "system", { headers: authHeader() });
};

const postSystem = (data) => {
  return axios.post(API_URLU + "system", data, { headers: authHeader() });
};

const postUserComp = (data) => {
  return axios.post(API_URLU + "ucompany", data, { headers: authHeader() });
};

// const getUserCompbk = (data) => {
//   return axios.get(API_URLU + 'ucompany/', data, { headers: authHeader() });
// };

const getUserComp = (id) => {
  return axios.get(API_URLU + "user-companies?userId=" + id, {
    headers: authHeader(),
  });
};

const postUserSystems = (data) => {
  return axios.post(API_URLU + "user-systems", data, { headers: authHeader() });
};

const getCompSystems = (id) => {
  return axios.get(API_URLU + "company-systems?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getUserCompSystems = () => {
  return axios.get(API_URLU + "user-company-systems", {
    headers: authHeader(),
  });
};

const getUserCompSystemsNew = (username) => {
  return axios.get(API_URLU + "user-company-systems-new/"+username, {
    headers: authHeader(),
  });
};


const getUserCompUSystems = () => {
  return axios.get(API_URLU + "user-company-usystems", {
    headers: authHeader(),
  });
};



const uploadFile = (file) => {
  let formData = new FormData();

  formData.append("file", file);

  return http.post("/singleUpload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadBankReceipt = (file) => {
  let formData = new FormData();

  formData.append("file", file);

  return http.post("/saveReceipt", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadExcel = (file) => {
  let formData = new FormData();

  formData.append("file", file);

  return http.post("/upload_chr_employees", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getFiles = () => {
  return http.get("/files");
};

const updatePass = (data) => {
  return axios.patch(API_URLU + "changepwd", data, { headers: authHeader() });
};

const updateUser = (data) => {
  return axios.get(
    API_URLU +
      "update-user-profile?id=" +
      data.id +
      "&longName=" +
      data.longName +
      "&email=" +
      data.email +
      "&phone=" +
      data.phone,
    { headers: authHeader() }
  );
};

const updateUserImg = (data) => {
  return axios.get(
    API_URLU + "update-user-image?id=" + data.id + "&photoUrl=" + data.photoUrl,
    { headers: authHeader() }
  );
};

const getUserRights = (data) => {
  return axios.get(
    API_URLU +
      "userRights?sstId=" +
      data.sstId +
      "&username=" +
      data.username +
      "&cmpId=" +
      data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getMenuLevels = (data) => {
  return axios.get(
    API_URLU +
      "get-menusbk?sstId=" +
      data.sstId +
      "&accessId=" +
      data.accessId +
      "&cmpId=" +
      data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getBranches = () => {
  return axios.get(API_URLU + "branch", { headers: authHeader() });
};

const getDepartments = () => {
  return axios.get(API_URLU + "get-departments", { headers: authHeader() });
};


const getTranTypes = (cmpId) => {
  return axios.get(API_URLU + "get-tran-types?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getCompanyBranches = (id) => {
  return axios.get(API_URLU + "company-branches/" + id, {
    headers: authHeader(),
  });
};
const putCompany = (cmpId, data) => {
  return axios.put(API_URLU + "company/" + cmpId, data, {
    headers: authHeader(),
  });
};
const getBranch = (id) => {
  return axios.get(API_URLU + "branch/" + id, { headers: authHeader() });
};

const putBranch = (id, data) => {
  return axios.put(API_URLU + "branch/" + id, data, { headers: authHeader() });
};
const postBranch = (data) => {
  return axios.post(API_URLU + "branch", data, { headers: authHeader() });
};

const getDefaultAccounts = (cmpId) => {
  return axios.get(API_URLU + "company-defaults/" + cmpId, {
    headers: authHeader(),
  });
};



const getCompanyUserBranches = (cmpId) => {
  return axios.get(API_URLU + "get-company-user-branches/" + cmpId, {
    headers: authHeader(),
  });
};

const getCustomerAttachments = (code) => {
  return axios.get(API_URLU + "customer_attachments?custCode=" + code, {
    headers: authHeader(),
  });
};

const postCustomerAttachments = (data) => {
  return axios.post(API_URLU + "customer_attachments", data, {
    headers: authHeader(),
  });
};

const getGeneralCodes = (cmpId, codeType) => {
  return axios.get(API_URLU + "cms-general-codes/" + cmpId + "/" + codeType, {
    headers: authHeader(),
  });
};

const postGeneralCodes = (data) => {
  return axios.post(API_URLU + "cms-general-codes", data, {
    headers: authHeader(),
  });
};

const putGeneralCodes = (id, data) => {
  return axios.put(API_URLU + "cms-general-codes/" + id, data, {
    headers: authHeader(),
  });
};
const getAttachedMenuItems = (cmpId, sstId, mutId) => {
  return axios.get(
    API_URLU + "attached-menu-items/" + cmpId + "/" + sstId + "/" + mutId,
    { headers: authHeader() }
  );
};

const getAvailableCodes = (pLevel, cmpId, sstId, allId) => {
  return axios.get(
    API_URLU +
      "available-codes/" +
      pLevel +
      "/" +
      cmpId +
      "/" +
      sstId +
      "/" +
      allId,
    { headers: authHeader() }
  );
};

const postMainMenu = (data) => {
  return axios.post(API_URLU + "main-menus", data, { headers: authHeader() });
};
const getAttachedGoneItems = (cmpId, goneId) => {
  return axios.get(
    API_URLU + "get-attached-gone-items/" + cmpId + "/" + goneId,
    { headers: authHeader() }
  );
};

const getAvailableMenuAccessCodes = (cmpId, goneId, mutId) => {
  return axios.get(
    API_URLU + "get-menu-access-codes/" + cmpId + "/" + goneId + "/" + mutId,
    { headers: authHeader() }
  );
};

const postGoneMenu = (data) => {
  return axios.post(API_URLU + "gone-menus", data, { headers: authHeader() });
};

const getAttachedGtwoItems = (cmpId, gtwoId) => {
  return axios.get(
    API_URLU + "get-attached-gtwo-items/" + cmpId + "/" + gtwoId,
    { headers: authHeader() }
  );
};

const getAttachedGthreeItems = (cmpId, gthreeId) => {
  return axios.get(
    API_URLU + "get-attached-gthree-items/" + cmpId + "/" + gthreeId,
    { headers: authHeader() }
  );
};

const getAvailableGoneAccessCodes = (cmpId, goneId, gtwoId) => {
  return axios.get(
    API_URLU + "get-gone-access-codes/" + cmpId + "/" + goneId + "/" + gtwoId,
    { headers: authHeader() }
  );
};

const getAvailableGtwoAccessCodes = (cmpId, gtwoId, gthreeId) => {
  return axios.get(
    API_URLU + "get-gtwo-access-codes/" + cmpId + "/" + gtwoId + "/" + gthreeId,
    { headers: authHeader() }
  );
};

const postGtwoMenu = (data) => {
  return axios.post(API_URLU + "gtwo-menus", data, { headers: authHeader() });
};

const postGthreeMenu = (data) => {
  return axios.post(API_URLU + "gthree-menus", data, { headers: authHeader() });
};

const getAllMenuDeleteStatus = (pid, pcat) => {
  return axios.get(
    API_URLU + "get-all-menu-delete-status/" + pid + "/" + pcat,
    { headers: authHeader() }
  );
};

const deleteSystem = (id) => {
  return axios.delete(API_URLU + "system/" + id, { headers: authHeader() });
};

const deleteSystemMenus = (id) => {
  return axios.delete(API_URLU + "system-menus/" + id, {
    headers: authHeader(),
  });
};

const deleteGroupOneItems = (id) => {
  return axios.delete(API_URLU + "group-one-menus/" + id, {
    headers: authHeader(),
  });
};

const deleteGroupTwoItems = (id) => {
  return axios.delete(API_URLU + "group-two-menus/" + id, {
    headers: authHeader(),
  });
};

const deleteGroupThreeItems = (id) => {
  return axios.delete(API_URLU + "group-three-menus/" + id, {
    headers: authHeader(),
  });
};

const getAssignedRoleDeleteStatus = (pid, pcat) => {
  return axios.get(
    API_URLU + "get-assigned-role-revoke-status/" + pid + "/" + pcat,
    { headers: authHeader() }
  );
};

const deleteMainMenu = (id) => {
  return axios.delete(API_URLU + "main-menus/" + id, { headers: authHeader() });
};

const deleteGoneMenu = (id) => {
  return axios.delete(API_URLU + "gone-menus/" + id, { headers: authHeader() });
};

const deleteGtwoMenu = (id) => {
  return axios.delete(API_URLU + "gtwo-menus/" + id, { headers: authHeader() });
};

const deleteGthreeMenu = (id) => {
  return axios.delete(API_URLU + "gthree-menus/" + id, {
    headers: authHeader(),
  });
};

const postSupportReqHeader=(data)=>{
  return axios.post(API_URLU+"post-support-request-header", data, {headers:authHeader()});
};

const putSupportReqHeader=(id, data)=>{
  return axios.put(API_URLU+"post-support-request-header/"+id, data, {headers:authHeader()});
};

const postSupportReqDetail=(data)=>{
  return axios.post(API_URLU+"post-support-request-detail", data, {headers:authHeader()});
};

const putSupportReqDetail=(id, data)=>{
  return axios.put(API_URLU+"post-support-request-detail/"+id, data, {headers:authHeader()});
};

const getEmployeeByUsername = (name) => {
  return axios.get(API_URLU + "chr_by_username/" + name, {
    headers: authHeader(),
  });
};

const getAccessCodeId=(cmpId, sstId, usrId)=>{
  return axios.get(API_URLU+'get-access-code-id?cmpId='+cmpId+'&sstId='+sstId+'&usrId='+usrId, {headers:authHeader()})
}

const getHelpDeskUsers =(data)=>{
  return axios.get(API_URLU+"get-user-helpdesk-roles?userRole="+data.accessCode+"&cmpId="+data.cmpId+
    "&sstId="+data.sstId+"&usrId="+data.usrId, {headers:authHeader()});
};

const getPolNo = (data) => {
  return axios.get(
    API_URLU +
      "getPolnumber?cmpId=" +
      data.cmpId +
      "&transType=" +
      data.transType +
      "&branchCode=" +
      data.branchCode +
      "&transDate=" +
      data.transDate,
    { headers: authHeader() }
  );
};

const getHelpDeskRequestsByDate=(data)=>{
  return axios.get(API_URLU+"help-desk-requests?cmpId="+data.cmpId+"&firstDate="+data.firstDate+"&lastDate="+data.lastDate+
    "&userName="+data.userName, {headers:authHeader()}
  );
};

const closePrevPeriod=(srdId)=>{
  return axios.get(API_URLU+"close-prev-period?srdId="+srdId, {headers:authHeader()})
}

const getSupportDetailsInfo=(srhId)=>{
  return axios.get(API_URLU+"support-detail-info?srhId="+srhId, {headers:authHeader()})
}

export default {
  getUserById,
  getUsers,
  postUser,
  getCompById,
  getCompanies,
  postComp,
  getSystemById,
  getSystems,
  postSystem,
  postUserComp,
  postUserSystems,
  getUserComp,
  getCompSystems,
  getUserCompSystems,
  getUserCompUSystems,
  getFiles,
  uploadFile,
  uploadExcel,
  updatePass,
  updateUser,
  updateUserImg,
  getCompanyUserBranches,
  uploadBankReceipt,
  getDefaultAccounts,
  getCustomerAttachments,
  postCustomerAttachments,
  getGeneralCodes,
  postGeneralCodes,
  putGeneralCodes,
  getAttachedMenuItems,
  getAvailableCodes,
  postMainMenu,
  getAttachedGoneItems,
  getAvailableMenuAccessCodes,
  postGoneMenu,
  getAttachedGtwoItems,
  getAvailableGoneAccessCodes,
  postGtwoMenu,
  getAttachedGthreeItems,
  getAvailableGtwoAccessCodes,
  postGthreeMenu,
  getAllMenuDeleteStatus,
  deleteSystem,
  deleteSystemMenus,
  deleteGroupOneItems,
  deleteGroupTwoItems,
  deleteGroupThreeItems,
  getAssignedRoleDeleteStatus,
  deleteMainMenu,
  deleteGoneMenu,
  deleteGtwoMenu,
  deleteGthreeMenu,
  getUserCompSystemsNew,
  postSupportReqHeader,
  putSupportReqHeader,
  postSupportReqDetail,
  putSupportReqDetail,
  getEmployeeByUsername,
  getMenuLevels,
  getUserRights,
  getBranches,
  getDepartments,
  getTranTypes,
  getCompanyBranches,
  putCompany,
  getBranch,
  putBranch,
  postBranch,
  getAccessCodeId,
  getHelpDeskUsers,
  getPolNo,
  getHelpDeskRequestsByDate,
  closePrevPeriod,
  getSupportDetailsInfo
};
